<script>
/* eslint-disable */

import NavBar from './NavBar.vue';
import LeftNavMenu from './LeftNavMenu.vue';
import SettingsComponent from './SettingsComponent.vue';

    export default {
    name: 'SettingsPage',
    props: { titolo: String },
    //components: { NavBar, LeftNavMenu,LoginComponent }
    components: { NavBar, LeftNavMenu, SettingsComponent }
}
</script>

<template lang="html">

        <body>
            <NavBar />
           <LeftNavMenu />
            <SettingsComponent />
        </body>   
   
</template>
  
<style lang="css">

</style>